<template>
    <div class="flex h-screen bg-default">
        <!-- Desktop sidebar -->
        <Sidebar v-if="!sidebarCollapsed" class="hidden lg:flex" />

        <!-- Mobile sidebar -->
        <USlideover v-model:open="mobileMenuOpen" side="left" :ui="{ content: 'w-72 max-w-[80vw]' }">
            <template #content>
                <Sidebar class="flex w-full" @navigate="mobileMenuOpen = false" />
            </template>
        </USlideover>

        <div class="flex min-w-0 flex-1 flex-col">
            <Topbar @toggle-menu="toggleMenu" />
            <main class="flex-1 overflow-auto bg-elevated/40 p-4 sm:p-8">
                <RouterView />
            </main>
            <Footer />
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { computed, ref } from 'vue'
    import { RouterView } from 'vue-router'

    import Footer from '@/layouts/components/Footer.vue'
    import Sidebar from '@/layouts/components/Sidebar.vue'
    import Topbar from '@/layouts/components/Topbar.vue'
    import { useAppStore } from '@/stores/app'

    const appStore = useAppStore()

    const mobileMenuOpen = computed({
        get: () => appStore.mobileMenuOpen,
        set: (value: boolean) => { appStore.mobileMenuOpen = value }
    })

    // The hamburger collapsed the desktop sidebar in the old layout, not only
    // the mobile drawer, which is why it stayed visible at every width.
    const sidebarCollapsed = ref(false)

    const toggleMenu = () => {
        if (window.matchMedia('(min-width: 1024px)').matches) {
            sidebarCollapsed.value = !sidebarCollapsed.value
            return
        }

        mobileMenuOpen.value = !mobileMenuOpen.value
    }
</script>
